import { URLS } from "@itaas/ports";

/** Modules dont l'essai démarre sur l'inscription self-service du produit (pas Suite). */
const SELF_SERVICE_TRIAL_SLUGS = new Set(["rh"]);

export function usesSelfServiceTrial(slugs: string[]): boolean {
  return (
    slugs.length > 0 &&
    slugs.every((slug) => SELF_SERVICE_TRIAL_SLUGS.has(slug))
  );
}

export function buildRhRegisterUrl(params: {
  email?: string;
  company?: string;
  utm_source?: string;
  utm_medium?: string;
  product?: string;
  modules?: string[];
  ref?: string;
}): string {
  const base = (import.meta.env.VITE_RH_URL ?? URLS.RH_WEB).replace(/\/$/, "");
  const url = new URL("/register", base);
  if (params.email) url.searchParams.set("email", params.email);
  if (params.company) url.searchParams.set("company", params.company);
  url.searchParams.set("utm_source", params.utm_source ?? "pep");
  url.searchParams.set("utm_medium", params.utm_medium ?? "trial");
  url.searchParams.set("product", params.product ?? "rh");
  const modules = params.modules?.length
    ? params.modules
    : params.product
      ? [params.product]
      : ["rh"];
  url.searchParams.set("modules", modules.join(","));
  if (params.ref) url.searchParams.set("ref", params.ref.trim().toUpperCase());
  return url.toString();
}

/** Page de connexion Suite avec tenant + email admin pré-remplis (post-essai PEP). */
export function buildSuiteLoginUrl(
  suiteUrl: string,
  params: { tenantSlug: string; adminEmail: string; module?: string },
): string {
  const base = suiteUrl.replace(/\/$/, "");
  const url = new URL("/login", `${base}/`);
  url.searchParams.set("tenant", params.tenantSlug.trim().toLowerCase());
  url.searchParams.set("email", params.adminEmail.trim().toLowerCase());
  if (params.module?.trim()) {
    url.searchParams.set("module", params.module.trim().toLowerCase());
  }
  return url.toString();
}

export function buildTrialDestinationUrl(
  selectedModules: string[],
  params: { email?: string; company?: string; ref?: string },
  suiteUrl: string
): string {
  if (usesSelfServiceTrial(selectedModules)) {
    return buildRhRegisterUrl({
      email: params.email,
      company: params.company,
      product: selectedModules[0] ?? "rh",
      modules: selectedModules,
      ref: params.ref,
    });
  }

  const u = new URL(suiteUrl);
  u.searchParams.set("trial", "1");
  u.searchParams.set("utm_source", "pep");
  u.searchParams.set("utm_medium", "trial");
  if (selectedModules.length) {
    u.searchParams.set("modules", selectedModules.join(","));
  }
  if (params.email) u.searchParams.set("email", params.email);
  if (params.company) u.searchParams.set("company", params.company);
  if (params.ref) u.searchParams.set("ref", params.ref.trim().toUpperCase());
  return u.toString();
}
